function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.45968 6.28125L10.0161 4.03125C10.1089 3.75 10.4798 2.4375 9.7379 1.3125C9.18145 0.46875 8.06855 0 6.49194 0H4.6371C3.06048 0 1.94758 0.46875 1.39113 1.3125C0.649194 2.4375 1.02016 3.65625 1.1129 4.03125L1.66936 6.28125C0.649194 7.3125 0 8.71875 0 10.3125C0 12.2812 1.02016 13.9687 2.50403 15H8.625C10.1089 13.9687 11.129 12.2812 11.129 10.3125C11.129 8.71875 10.4798 7.3125 9.45968 6.28125ZM3.33871 5.15625L2.875 3.5625V3.46875C2.875 3.46875 2.68952 2.8125 2.96774 2.4375C3.15323 2.0625 3.70968 1.875 4.6371 1.875H6.49194C7.32661 1.875 7.97581 2.0625 8.25403 2.34375C8.53226 2.71875 8.34677 3.375 8.34677 3.375L7.88306 5.15625C7.14113 4.875 6.39919 4.6875 5.56452 4.6875C4.72984 4.6875 3.9879 4.875 3.33871 5.15625Z",
  fill: "#FFA826"
});

var SvgIconEquipment = function SvgIconEquipment(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconEquipment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-equipment.a2c9baec.svg";
export { ForwardRef as ReactComponent };